import Resource from './common/resource';

class CustomAgents extends Resource {
  path = 'agent/custom';
}

export default CustomAgents;
